module.exports = __webpack_public_path__ + "img/img04.32899ca1.png";